import React, { forwardRef, useImperativeHandle, useState } from 'react';

import * as General from '../General/General';
import * as rsuite from 'rsuite';
import { trackPromise } from 'react-promise-tracker';
import axios from 'axios';
import { forEach } from 'rsuite/esm/internals/utils/ReactChildren';

const Modal_UpdateConfirm = forwardRef((props, ref) => {

    const [ItemList, setItemList] = useState([]);
    const [Tax, setTax] = useState(0);
    const [FiscalYearId, setFiscalYearId] = useState(localStorage.getItem("FiscalYearId"));
    const [Code, setCode] = useState("");
    const [HeaderPrice, setHeaderPrice] = useState(0);
    const [ShowDis, setShowDis] = useState(0);
    const [StoreRoom, setStoreRoom] = useState("");
    const [TypeComment, setTypeComment] = useState("");
    const [Type, setType] = useState(-1);
    const [InsertDate, setInsertDate] = useState("");
    const [Supplier, setSupplier] = useState("")
    const [CheckedAll, setCheckedAll] = useState(false)
    const [Id, setId] = useState(General.GuidEmpty());
    const [Open, setOpen] = useState(false);
    const toaster = rsuite.useToaster();



    useImperativeHandle(ref, () => ({
        Bind(id) {
            setId(id);
            setOpen(true);
            Bind(id)


        },
    }),
        [props.value])



    const Bind = (id) => {

        trackPromise(
            fetch(General.ApiRoute() + '/StoreRoomReciept/GetHeaderById', {
                method: 'Get',
                headers: {
                    'ApiKey': General.APIKey(),
                    'HeaderId': id
                },
                credentials: 'include'
            })
                .then(res => res.json())
                .then(result => {
                    setInsertDate(result.insertDate)
                    setTypeComment(result.typeComment);
                    setType(result.type);
                    setHeaderPrice(result.price);
                    setStoreRoom(result.storeRoom);
                    setSupplier(result.supplier);
                    setCode(result.code);
                    setItemList(result.children);
                    setTax(result.children[0].tax)
                    setShowDis(result.children.findIndex(x => x.discountPercent != 0))


                })
        )

    };

    const UpdateConfirm = () => {
        console.dir(ItemList)
        var RequestOptions = {
            data: {
                "Id": Id,
                "Code": Code,
                "StoreRoom": StoreRoom,
                "Children": ItemList,
            },
            url: General.ApiRoute() + "/StoreRoomReciept/UpdateTotalConfirm",
            method: "post",
            withCredentials: true,

            headers: {
                'ApiKey': General.APIKey(),
                'Content-Type': 'application/json'
            }
        }


        trackPromise(
            axios(RequestOptions)
                .then(function (result) {
                    if (result.data == "OK") {
                        toaster.push(General.ShowMessage('success', General.SuccessMessage("ذخیزه شده است")), 'topCenter')
                        props.onSubmit();
                        Bind(Id)

                    }
                    else {
                        toaster.push(General.ShowMessage('error', General.ErrorMessage(result.data)), 'topCenter')

                    }
                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')

                })
        )
    }

    const CheckAll = (check) => {
        setCheckedAll(check)
        ItemList.forEach(item => {
            if (item.confirmId == General.GuidEmpty())
                item.isComfirm = check;
        });

    }

    const ItemChecked = (check, id) => {
        var temp = [...ItemList];
        var index = temp.findIndex(x => x.id == id);
        if (index != -1) {
            temp[index].isComfirm = check;
        }
        setItemList(temp);
        console.dir(temp.findIndex(x => !x.isComfirm))
        setCheckedAll(temp.findIndex(x => !x.isComfirm) == -1 ? true : false)


    }



    return (
        <rsuite.Modal open={Open} size="full" onClose={() => setOpen(false)} style={{ "zIndex": 10000 }}>
            <rsuite.Modal.Header>
                <rsuite.Modal.Title><b>تایید {TypeComment}</b></rsuite.Modal.Title>
            </rsuite.Modal.Header>
            <rsuite.Modal.Body>

                <div>

                    <table class="table table-sm table-borderless">
                        <tr>
                            <td>
                                <b>شماره رسید :   </b>{Code}
                            </td>
                            <td className='text-end'>
                                <b> تاریخ صدور:   </b> {InsertDate}
                            </td>
                            <td className='text-end'>
                                <b> انبار مقصد:   </b> {StoreRoom}
                            </td>
                            <td className={Type == 1 || Type == 3 ? 'text-end' : "hide"}>
                                <b> تامین کننده: </b> {Supplier}
                            </td>
                            <td className={Type == 2 ? 'text-end' : "hide"}>
                                <b> انبار مبدا: </b> {Supplier}
                            </td>

                        </tr>


                    </table>


                </div>
                <hr />

                <div>



                    <rsuite.Panel className="bg-white mt-2">

                        <rsuite.Table
                            // rowKey={rowKey}
                            // rowExpandedHeight={210}
                            height={500}
                            data={ItemList}
                        >

                            <rsuite.Table.Column className="w-10p" align="center" fixed >
                                <rsuite.Table.HeaderCell>
                                    <rsuite.Checkbox value={CheckedAll} checked={CheckedAll} onChange={(e, checked) => CheckAll(checked)} />

                                </rsuite.Table.HeaderCell>
                                <rsuite.Table.Cell>
                                    {(rowData) => {
                                        return <>

                                            <rsuite.Checkbox disabled={rowData.confirmId == General.GuidEmpty() ? false : true} value={rowData.isComfirm} checked={rowData.isComfirm} onChange={(e, check) => ItemChecked(check, rowData.id)} />

                                        </>


                                    }}

                                </rsuite.Table.Cell>
                            </rsuite.Table.Column>

                            <rsuite.Table.Column resizable>
                                <rsuite.Table.HeaderCell>مبنا</rsuite.Table.HeaderCell>
                                <rsuite.Table.Cell>
                                    {(rowData) => {
                                        return <>
                                            <rsuite.Text className={rowData.confirmId == General.GuidEmpty() ? '' : 'text-success'}>{rowData.refTitle}</rsuite.Text>
                                        </>


                                    }}

                                </rsuite.Table.Cell>
                            </rsuite.Table.Column>

                            <rsuite.Table.Column flexGrow={2} fullText resizable>
                                <rsuite.Table.HeaderCell>محصول </rsuite.Table.HeaderCell>
                                <rsuite.Table.Cell>
                                    {(rowData) => {
                                        return <>
                                            <text className={rowData.confirmId == General.GuidEmpty() ? '' : 'text-success'}>{rowData.product}</text>
                                        </>


                                    }}
                                </rsuite.Table.Cell>

                            </rsuite.Table.Column>


                            <rsuite.Table.Column width={100} >
                                <rsuite.Table.HeaderCell>تعداد</rsuite.Table.HeaderCell>
                                <rsuite.Table.Cell>
                                    {(rowData) => {
                                        return <>
                                            <rsuite.Text className={rowData.confirmId == General.GuidEmpty() ? '' : 'text-success'}>{rowData.count}</rsuite.Text>
                                        </>
                                    }}
                                </rsuite.Table.Cell>

                            </rsuite.Table.Column>
                        </rsuite.Table>

                    </rsuite.Panel>

                </div>

            </rsuite.Modal.Body>
            <rsuite.Modal.Footer>
                <rsuite.Button appearance="primary" color="green" onClick={() => UpdateConfirm()}>
                    ثبت
                </rsuite.Button>
                <rsuite.Button appearance="subtle" onClick={() => setOpen(false)}>
                    بستن
                </rsuite.Button>
            </rsuite.Modal.Footer>
        </rsuite.Modal>
    )
});

export default Modal_UpdateConfirm;